export default __webpack_public_path__ + "static/media/i2.94b348a7.jpg";